export const ACCESS_LEVEL_LABELS = {
  Super_Admin: "Super Admin",
  company_admin: "Key User",
  Admin: "Admin",
  User: "User",
};

export const COMPANY_ADMIN_ASSIGNERS = ["Super_Admin", "company_admin"];

export const formatAccessLevel = (value) =>
  ACCESS_LEVEL_LABELS[value] || value || "User";

export const canAssignCompanyAdmin = (accessLevel) =>
  COMPANY_ADMIN_ASSIGNERS.includes(accessLevel);

// Mitarbeitende haben im Web eine eigene, schmale Ansicht (Schichtplan lesen,
// eigene Verfügbarkeit, eigene Reports, Profil). Gegenstück im Backend:
// USER_WEB_ROUTES in backend_web/auth.py.
export const EMPLOYEE_ACCESS_LEVEL = "User";
export const EMPLOYEE_HOME_PATH = "/shiftplan";

export const isEmployeeAccessLevel = (value) => value === EMPLOYEE_ACCESS_LEVEL;
